import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import { Loading } from 'components/Loading';
import NoResults from 'graphics/NoResults';
import { useDispatch, useSelector } from 'react-redux';
import { getSelectWorkOrderOpOptions } from 'lib/selectors/getSelectWorkOrderOp';
import { actionPatchSelectWorkOrderOpOptions } from 'lib/actions';
import { Button } from '@m12s/component-library';
import { useTranslation } from 'react-i18next';
import _capitalize from 'lodash/capitalize';
import {
  CenteredMessage,
  CenteredMessageContent,
  CenteredMessageTitleText,
} from './styled';

const EmptyMessage = ({ loading, error }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { isSearchMode, onlyMachineChecked } = useSelector(
    getSelectWorkOrderOpOptions
  );

  const setIsSearchMode = useCallback(
    (value) => {
      dispatch(
        actionPatchSelectWorkOrderOpOptions({
          isSearchMode: value,
        })
      );
    },
    [dispatch]
  );

  const title = useMemo(() => {
    return !isSearchMode
      ? onlyMachineChecked
        ? _capitalize(t('no scheduled jobs'))
        : _capitalize(t('no assigned jobs'))
      : _capitalize(t('no results found'));
  }, [isSearchMode, onlyMachineChecked, t]);

  if (loading) {
    return <Loading />;
  }
  if (error) {
    return (
      <CenteredMessage>Error loading scheduled operations</CenteredMessage>
    );
  }

  return (
    <CenteredMessage isSearchMode={isSearchMode}>
      <CenteredMessageContent>
        {!isSearchMode && <NoResults />}
        <CenteredMessageTitleText>{title}</CenteredMessageTitleText>
      </CenteredMessageContent>
      {!isSearchMode && (
        <Button
          onClick={() => {
            setIsSearchMode(true);
          }}
        >
          {_capitalize(t('search all jobs'))}
        </Button>
      )}
    </CenteredMessage>
  );
};

EmptyMessage.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.object,
};

export default EmptyMessage;
